<template>

  <div class="w-full flex cursor-move idea-card" :class="{'flex-col-reverse': showingImages}">
    <div v-if="!showingImages" class="h-auto w-24 flex-none bg-cover rounded-t-none rounded-l text-center overflow-hidden bg-center" :style="bgImage" :title="idea.name" @click="showBigImages">
    </div>
    <div v-else class="w-full idea-image-slider" @click="showingImages = false">
      <img style="max-width: 400px;display: inline" v-for="image in idea.images" :src="image">
    </div>
    <div class="w-full border-r border-t border-gray-light bg-white rounded-r p-2 flex flex-col justify-between leading-normal" :class="{'border-l rounded-l': showingImages, 'border-b': !showingImages}">
      <div style="position: relative;">
        <button v-show="removable" class="close-icon text-gray-light px-2 hover:text-black" @click="remove">
          &times;
        </button>
        <header class="text-black font-bold mb-1 leading-tight idea-card-header">
            {{idea.name}}
            <idea-icon :idea="idea" />          
        </header>
        <div style="min-height:3.25rem">
          <p v-if="idea.address || idea.website" class="text-sm leading-tight mb-1 text-gray">
            <a target="_blank" class="text-gray hover:text-gray-700 underline" :href="idea.website">Website</a>
            <span v-if="idea.address && idea.website">&middot;</span>
            <a v-if="idea.address" target="_blank" class="text-gray hover:text-gray-700 no-underline hover:underline" :href="idea.url">{{idea.address}}</a>
          </p>
          <p style="min-height: 1rem" v-if="!editingDescription" @click="editingDescription = true" class="text-gray-500 text-sm leading-tight">
            {{idea.description}}
          </p>
          <input v-else ref="description" @keyup.enter="updateDescription" @blur="updateDescription" v-model="idea.description" class="input-description w-full text-sm">
        </div>
      </div>
      
    </div>
  </div>

</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import IdeaIcon from '@/components/IdeaIcon'

  export default {
    components: {
      IdeaIcon,
    },
    props: {
      idea: Object,
      removable: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        editingDescription: false,
        showingImages: false,
      }
    },
    computed: {
      ...mapGetters([
        'list'
      ]),
      bgImage () {
        return `background-image: url('${this.image}')`
      },
      image () {
        if (!this.idea.images || !this.idea.images.length) {
          return 'https://us.123rf.com/450wm/puruan/puruan1702/puruan170204912/72146428-pin-location-map-icon-in-metallic-gray-color-style-.jpg?ver=6'
        }
        return this.idea.images[0]
      }
    },
    methods: {
      ...mapActions([
        'updateIdeaOnList'
      ]),
      remove () {
        if (confirm(`Are you sure you want to get rid of ${this.idea.name}?`)) {
          this.$emit('remove')
        }
      },
      showBigImages () {
        if ('images' in this.idea && this.idea.images) {
          this.showingImages = true
        }
      },
      updateDescription () {
        this.updateIdeaOnList({
          data: {
            description: this.idea.description,
          },
          listId: this.list._id,
          ideaId: this.idea.id
        })

        if (!this.idea.description) {
          return
        }

        this.editingDescription = false
      }
    }
  }
</script>

<style>
  .idea-card-header {
    font-size: 18px;
  }
  @media screen and (min-width: 768px) {
    .idea-card-header {
      font-size: 20px;
    }

  }
  .cursor-move {
    cursor: -webkit-grab;
  }
  .sortable-chosen,
  .sortable-ghost {
    cursor: -webkit-grabbing!important;
  }
  .close-icon {
    display: block;
    opacity: 0.4;
    position: absolute;
    top: -13px;
    right: -11px;
  }
  .idea-image-slider {
    overflow-x: scroll;
  }
  .idea-image-slider img {
    width: 100%;
    cursor: pointer;
  }
  .input-description {
    background: #eee;
  }
</style>



// WEBPACK FOOTER //
// IdeaCard.vue?3f9f600f